<template>
  <div class="ebPagination">
    <el-pagination @current-change="pagination" background layout="prev, pager, next" :page-size="pageSize" :current-page.sync="currentPageTemp"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'ebPagination',
  props: ['total', 'page-size', 'current-page'],
  data() {
    return {};
  },
  watch: {},
  computed: {
    currentPageTemp: {
      get: function() {
        return this.currentPage;
      },
      set: function(val) {
        this.$emit('update:currentPage', val);
      }
    }
  },
  methods: {
    pagination: function(data) {
      this.$emit('current-change', data);
    }
  }
};
</script>
<style lang="less" scoped>
.ebPagination {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
</style>
